module.exports = __webpack_public_path__ + "img/back.9fff98b8.jpg";